export default __webpack_public_path__ + "static/media/UA.89444853.svg";